import { isEmpty } from 'lodash'
import {
	CREATE_REFERRALS,
	DISMISS_BULLETIN_MUTATION,
	GET_AUTHORIZED_WORKER,
	GET_BULLENTINS_QUERY,
	GET_GENERAL_RANKED_JOBS_QUERY,
	GET_HOT_JOBS_QUERY,
	GET_JOB_DISCOVERS_QUERY,
	GET_SUGGESTION_JOBS_QUERY,
	GET_WORKER_REFERRAL_LINK,
	apolloClient,
} from '~/common/apollo'
import { action, computed, observable, persist, store } from '~/common/mobx.decorator'
import { careFindJobStore } from '~/features/care-find-job/care-find-job.store'
import { authStore, notifyStore } from '~/stores'
import { availableJobStore, featuredJobStore, jobStore } from '~/stores/jobs'
import { matchesJobStore } from '~/stores/jobs/matches.job.store'
import { careSettingsStore } from '~/features/care-settings/care-settings.store'

@store({ persist: true })
class CareHomeStore {
	@observable numCityCall = 0
	@observable numJobCall = 0

	@observable citiesMatches = []
	@observable workAuthorized = {}
	@observable hotJobs = []
	@observable suggestedJobs = []
	@observable popularCities = []
	@observable bulletins = []
	@observable phoneAuthorized = null
	@observable phoneVerifiedAt = null
	@observable workerInfo = null
	@observable settings = {}
	@observable discoverLastSearch = {}
	@observable totalCountLastSearch = 0
	@observable similarJobFilter = {}
	@observable lastSearchTitle = ''
	@observable listWorkerCheckout = null
	@observable summaryWorkedShiftActivities = null
	@observable listWorkerCheckoutDetail = null
	@observable activeCheckoutId = ''
	@observable currentCheckoutItem = null
	@observable referralLink = ''
	@observable discovers = {}

	@persist @observable userJustCompletedProfile = false // TODO: back to `false` after testing

	@computed
	get citiesMatchesItems() {
		return this.citiesMatches
	}

	@computed
	get hotJobsItems() {
		return this.hotJobs
	}

	@computed
	get suggestedJobsItems() {
		return this.suggestedJobs
	}

	@computed
	get popularCitiesItems() {
		return this.popularCities
	}

	@action
	updateUserJustCompletedProfile = (completed) => {
		this.userJustCompletedProfile = completed
	}

	@action
	setBestMatches = (jobs, total) => {
		this.bestMatches.data = jobs
		this.bestMatches.total = total || jobs.length || 0
	}

	@action
	setFeaturedJobs = (jobs, total) => {
		this.featuredJobs.data = jobs
		this.featuredJobs.total = total || jobs.length || 0
	}

	@action
	setSimilarJobFilter = (filter) => {
		this.similarJobFilter = careFindJobStore.transferDataParams(filter)
	}

	/** @deprecated Will remove soon */
	@action
	fetchPopularCities = async () => {
		try {
			const response = await apolloClient.query({
				query: GET_GENERAL_RANKED_JOBS_QUERY,
			})
			this.popularCities = response?.data?.popularCities
		} catch (error) {
			console.error(error.message)
		}
	}

	/** @deprecated Will remove soon */
	@action
	fetchSuggestedJobs = async () => {
		const response = await apolloClient.query({ query: GET_SUGGESTION_JOBS_QUERY, variables: { limit: 5, offset: 0 } })
		this.suggestedJobs = response?.data?.suggestionJobs?.nodes
	}

	/** @deprecated Will remove soon */
	@action
	setHotJob = (jobs) => {
		this.hotJobs = jobs
	}

	/** @deprecated Will remove soon */
	@action
	setSuggestedJob = (jobs) => {
		this.suggestedJobs = jobs
	}
	/** @deprecated Will remove soon */
	@action
	fetchHotJobs = async () => {
		const response = await apolloClient.query({
			query: GET_HOT_JOBS_QUERY,
			variables: {
				filter: { hotJob: true },
				first: 3,
			},
		})
		this.hotJobs = response.data?.searchJobs?.nodes
	}

	@action
	fetchBulletins = async () => {
		const { data } = await apolloClient.query({
			query: GET_BULLENTINS_QUERY,
		})
		this.bulletins = data?.bulletins
	}

	@action
	fetchWorkerCheckout = async () => {
		try {
			// TODO: Refactoring
		} catch (error) {
			console.error(error.message)
		}
	}

	@action
	fetchWorkerCheckoutDetail = async () => {
		try {
			// TODO: Refactoring
		} catch (error) {
			console.error(error.message)
		}
	}
	@action
	setListWorkerCheckout = (value) => {
		return (this.listWorkerCheckout = value)
	}

	@action
	setCurrentCheckoutItem = (value) => {
		return (this.currentCheckoutItem = value)
	}

	@action
	setActiveCheckoutId = (value) => {
		return (this.activeCheckoutId = value)
	}

	@action
	dismissBulletinForAnonymous = async (bulletinId) => {
		try {
			const deleteBulletinsAnoParsed = JSON.parse(window.localStorage.getItem('deleteBulletinsAno')) || []
			let deleteBulletinsAno = isEmpty(deleteBulletinsAnoParsed) ? [] : deleteBulletinsAnoParsed
			deleteBulletinsAno.push(bulletinId)
			window.localStorage.setItem('deleteBulletinsAno', JSON.stringify(deleteBulletinsAno))
			this.fetchBulletins()
			notifyStore.success('$MESSAGES.SUCCESSFUL')
		} catch (error) {
			notifyStore.error(error.message)
		}
	}

	/** @deprecated Will remove soon */
	@action
	dissmisBulletin = async (bulletinId) => {
		if (authStore.isAnonymous) {
			this.dismissBulletinForAnonymous(bulletinId)
			return
		}

		try {
			await apolloClient.mutate({
				mutation: DISMISS_BULLETIN_MUTATION,
				variables: { bulletinId },
			})
			notifyStore.success('$MESSAGES.SUCCESSFUL')
			this.fetchBulletins()
		} catch (error) {
			notifyStore.error(error.message)
		}
	}

	@action
	fetchDiscovers = async () => {
		try {
			const { data } = await apolloClient.query({
				query: GET_JOB_DISCOVERS_QUERY,
			})
			this.discovers = data?.discovers || {}
		} catch (error) {
			console.error(error.message)
		}
	}

	@action
	fetchWorkerAuthorized = async () => {
		try {
			const { data } = await apolloClient.query({
				query: GET_AUTHORIZED_WORKER,
				variables: {
					workerId: authStore.id,
				},
			})
			this.workerInfo = data?.worker
			this.phoneAuthorized = data?.worker?.phone
			this.phoneVerifiedAt = data?.worker?.phoneVerifiedAt
		} catch (error) {
			notifyStore.error(error.message)
		}
	}

	@action
	fetchWorkerReferralLink = async () => {
		try {
			const { data } = await apolloClient.query({
				query: GET_WORKER_REFERRAL_LINK,
			})
			this.referralLink = data?.worker?.staffingReferralUser?.acceptUrl
			return data?.worker?.staffingReferralUser?.acceptUrl
		} catch (error) {
			notifyStore.error(error.message)
		}
	}

	@action
	homeInit = async () => {
		try {
			// await careStore.fetchWorkerBestMatchesJobParam()
			await Promise.all([
				availableJobStore.fetchData(true, {}, { first: 3 }),
				featuredJobStore.fetchData(true, {}, { first: 3 }),
				matchesJobStore.fetchData(true, {}, { first: 3 }),
				careSettingsStore.fetchNotificationSetting(),
			])
		} catch (error) {
			console.error(error.message)
		}
	}

	/**
	 * Function handle user click on the close button of the dialog
	 * with title "Your account has been successfully created and you have applied to WorldWide HealthStaff"
	 * */
	@action
	onCloseDialog = () => {
		this.updateUserJustCompletedProfile(false)
	}

	@action
	cleanup = () => {
		this.updateUserJustCompletedProfile(false)
	}

	@action
	createReferrals = async () => {
		try {
			const { data } = await apolloClient.mutate({
				mutation: CREATE_REFERRALS,
			})
			notifyStore.success('$MESSAGES.SUCCESSFUL')
			this.fetchBulletins()
			return data?.createStaffingReferralWorker?.acceptUrl
		} catch (error) {
			notifyStore.error(error.message)
			return false
		}
	}
}

export const homeStore = new CareHomeStore()
